import { render, staticRenderFns } from "./IconScroller.vue?vue&type=template&id=65864ebd&scoped=true"
import script from "./IconScroller.vue?vue&type=script&lang=js"
export * from "./IconScroller.vue?vue&type=script&lang=js"
import style0 from "./IconScroller.vue?vue&type=style&index=0&id=65864ebd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65864ebd",
  null
  
)

export default component.exports